import { render } from "./confirmMessage.vue?vue&type=template&id=44769012&scoped=true"
import script from "./confirmMessage.vue?vue&type=script&lang=js"
export * from "./confirmMessage.vue?vue&type=script&lang=js"

import "./confirmMessage.vue?vue&type=style&index=0&id=44769012&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44769012"]])

export default __exports__